/*
  name : isPartOfElement 
  desc : check if click is outside elm
  params : elm => node / target => e.target
*/
export function isPartOfElement(elm, target) {
    return (
        target === elm ||
        elm.contains(target)
    );
}

/*
  name : replaceContent 
  desc : Replace html content
  params : html => data.html form ajax request / selector => selector to replace
*/
export function replaceContent(html, selector) {
  const $root = document.createElement("div");
  $root.innerHTML = html;

  const oldContentWrapper = document.querySelector(selector);
  const newContentWrapper = $root.querySelector(selector);

  oldContentWrapper.replaceWith(newContentWrapper);
}
